import {
  createResource,
  postResource,
  // deleteResource,
  // postFormDataPrettifierResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL = 'ticket-management/'

const CREATE_BUYER_URL = prefixAPI('{label}/buyer-register/', MODEL)
const CHECK_TICKETS_URL = prefixAPI('{label}/find/', MODEL)

export const createBuyer = createResource(
  CREATE_BUYER_URL, postResource
)
export const checkTickets = createResource(
  CHECK_TICKETS_URL, postResource
)
